import { render, staticRenderFns } from "./FilterBlockchainVersion.vue?vue&type=template&id=c1624d32&scoped=true"
import script from "./FilterBlockchainVersion.vue?vue&type=script&lang=ts"
export * from "./FilterBlockchainVersion.vue?vue&type=script&lang=ts"
import style0 from "./FilterBlockchainVersion.vue?vue&type=style&index=0&id=c1624d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1624d32",
  null
  
)

export default component.exports